import { render } from "./HotPointComponentNormal.vue?vue&type=template&id=d81db30a&scoped=true"
import script from "./HotPointComponentNormal.vue?vue&type=script&lang=js"
export * from "./HotPointComponentNormal.vue?vue&type=script&lang=js"

import "./HotPointComponentNormal.vue?vue&type=style&index=0&id=d81db30a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d81db30a"]])

export default __exports__